// ===============================================================
// 🌍 LanguagePage.js — اختيار اللغة (FINAL / LOCKED) — LIVORA FIX ✅
// ===============================================================

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/common/TopBar";
import { useSettings } from "../store/SettingsContext";
import { persistManualLanguage } from "../utils/languagePref";
import "./LanguagePage.css";
import "../i18n";

function LanguagePage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { language, setLanguage } = useSettings();

  const languages = [
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "tr", name: "Türkçe", flag: "🇹🇷" },
    { code: "ru", name: "Русский", flag: "🇷🇺" },
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "it", name: "Italiano", flag: "🇮🇹" },
    { code: "pt", name: "Português", flag: "🇵🇹" },
    { code: "fa", name: "فارسی", flag: "🇮🇷" },
    { code: "id", name: "Indonesia", flag: "🇮🇩" },
    { code: "ph", name: "Filipino", flag: "🇵🇭" },
    { code: "el", name: "Ελληνικά", flag: "🇬🇷" },
    { code: "he", name: "עברית", flag: "🇮🇱" },
    { code: "ku", name: "Kurdî", flag: "🇹🇯" },
  ];

  const RTL_LANGS = ["ar", "fa", "he"];

  const changeLanguage = async (lang) => {
    try {
      // ✅ 1) persist manual choice (livora_lang + livora_lang_manual)
      persistManualLanguage(lang);
      localStorage.setItem("i18nextLng", lang);

      // ✅ 2) i18n change (real translation switch)
      await i18n.changeLanguage(lang);

      // ✅ 3) update context (UI state)
      setLanguage(lang);

      // ✅ 4) direction update (LIVORA plan: direction only here, not inside components)
      const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
      document.documentElement.dir = dir;
      document.documentElement.lang = lang;
    } catch (e) {
      console.error("changeLanguage error:", e);
    }
  };

  return (
    <div className="language-root">
      <TopBar
        title={t("select_language", { defaultValue: "Select language" })}
        onBack={() => navigate(-1)}
      />

      <div className="language-list">
        {languages.map((lang) => (
          <div
            key={lang.code}
            className={`language-item ${language === lang.code ? "active" : ""}`}
            onClick={() => changeLanguage(lang.code)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") changeLanguage(lang.code);
            }}
          >
            <span className="lang-flag">{lang.flag}</span>
            <span className="lang-name">{lang.name}</span>

            {language === lang.code && <span className="check">✔</span>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default LanguagePage;
